import * as TYPES from './_types';
import { apiService } from 'utils/api';

export const fetchUsers = params => {
  return dispatch => {
    dispatch({
      type: TYPES.FETCH_USERS,
      payload: params
    });

    return apiService
      .get('/users', { params })
      .then(response => {
        const users = response.data;
        dispatch({ type: TYPES.FETCH_USERS_SUCCESS, payload: users });

        return response.data;
      })
      .catch(error => {
        dispatch({ type: TYPES.FETCH_USERS_FAILURE });
      });
  };
};

export const updateStatus = params => {
  return dispatch => {
    dispatch({
      type: TYPES.UPDATE_USER_STATUS
    });

    return apiService
      .put('/users', { params })
      .then(response => {
        const users = response.data;
        dispatch({ type: TYPES.UPDATE_USER_STATUS_SUCCESS, users });

        return response.data;
      })
      .catch(error => {
        dispatch({ type: TYPES.UPDATE_USER_STATUS_FAILURE });
      });
  };
};



// WEBPACK FOOTER //
// ./src/views/users/_actions.js